// import {readFile as read} from 'fs';
const sum = (arr) => arr.reduce((a, v) => a + v, 0);
const avg = (arr) => sum(arr) / arr.length;

// Adaption of https://www.30secondsofcode.org/js/s/standard-deviation
const stdDev = (arr, usePopulation = false) => {
  const mean = avg(arr);
  return Math.sqrt(
    sum(arr.reduce((a, v) => a.concat((v - mean) ** 2), [])) /
      (arr.length - (usePopulation ? 0 : 1))
  );
};

// Source: https://www.30secondsofcode.org/js/s/order-by
const orderBy = (arr, props, orders) =>
  [...arr].sort((a, b) =>
    props.reduce((acc, prop, i) => {
      if (acc === 0) {
        const [p1, p2] = orders && orders[i] === 'desc' ? [b[prop], a[prop]] : [a[prop], b[prop]];
        acc = p1 > p2 ? 1 : p1 < p2 ? -1 : 0;
      }
      return acc;
    }, 0)
  );

const deepOrderBy = (arr, parentProp, childProps, childOrders) => {
  return [...arr].sort((a, b) =>
    childProps.reduce((acc, prop, i) => {
      if (acc === 0) {
        const [p1, p2] =
          childOrders && childOrders[i] === 'desc'
            ? [b[parentProp][prop], a[parentProp][prop]]
            : [a[parentProp][prop], b[parentProp][prop]];
        acc = p1 > p2 ? 1 : p1 < p2 ? -1 : 0;
      }
      return acc;
    }, 0)
  );
};

/* const readJson = (filename) => {
  try {
    return JSON.parse(read(`../data/players/${filename}.json`, 'utf-8'));
  } catch (err) {
    console.warn('Error reading', filename, err);
    return {};
  }
} */

export {avg, stdDev, orderBy, deepOrderBy};
